import template from './flight-rules-link.html';
import {flightStates} from './../flights-routes';

const DIRECTIVE_NAME = FlightRulesLink.DIRECTIVE_NAME = 'ktFlightRulesLink';
export default function FlightRulesLink() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: FlightRulesLinkController,
        controllerAs: '$ctrl',
        scope: {
            recommendation: `=${DIRECTIVE_NAME}`,
            fare: `=${DIRECTIVE_NAME}Fare`,
            searchParameters: `=${DIRECTIVE_NAME}SearchParameters`,
            selectedFlights: `=${DIRECTIVE_NAME}SelectedFlights`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };
}

export function FlightRulesLinkController(
    $window,
    $state,
    userService,
    flightRecommendationService
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
        navigateToRulesPage,
    });

    function $onInit() {
    }

    function navigateToRulesPage() {
        const groups = flightRecommendationService
            .getSelectedGroupsInRecommendation(vm.recommendation, vm.selectedFlights)
            .map(({FlightGroupId}) => FlightGroupId);

        const params = {
            groups,
            search: vm.searchParameters.SearchId,
            recommendation: vm.recommendation.RecommendationId,
            fare: vm.fare.FareRecommendationGuid,
            culture: userService.getCulture(),
            adult: getTravellerValue(vm.searchParameters.Travelers.Adult),
            child: getTravellerValue(vm.searchParameters.Travelers.Child),
            infant: getTravellerValue(vm.searchParameters.Travelers.Infant),
        };

        const url = $state.href(flightStates.FLIGHTS_RESULTS_RULES, params);
        $window.open(url, '_blank');

        function getTravellerValue(traveller) {
            return traveller
                && (traveller.value || Array.isArray(traveller) && traveller.length)
                || 0;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/flights/flight-rules-link/flight-rules-link-component.js